import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { COLORS } from './storeManagementConstants';
import {
  KitchenAvatar,
  getStatusDisplay,
  getStoreVisibilityDisplay,
} from './storeManagementParts';

export function StoreManagementRowMenu({
  menuAnchor,
  menuRow,
  onClose,
  onViewStore,
  onUpdateStatus,
}) {
  return (
    <Menu
      anchorEl={menuAnchor}
      open={Boolean(menuAnchor)}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        elevation: 0,
        sx: {
          borderRadius: '16px',
          minWidth: 238,
          mt: 0.75,
          border: `1px solid ${COLORS.border}`,
          boxShadow:
            '0 4px 24px rgba(63, 63, 110, 0.12), 0 1px 3px rgba(0,0,0,0.06)',
          overflow: 'visible',
        },
      }}
    >
      {menuRow && (
        <>
          <Box sx={{ px: 2, pt: 2, pb: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.25 }}>
              <KitchenAvatar name={menuRow.kitchenName} size={32} radius="8px" />
              <Typography
                sx={{
                  fontFamily: 'Inter Bold, sans-serif',
                  fontSize: 13,
                  fontWeight: 700,
                  color: COLORS.ink,
                  lineHeight: 1.3,
                }}
              >
                {menuRow.kitchenName}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
              {getStatusDisplay(menuRow.status)}
              {getStoreVisibilityDisplay(menuRow.storeVisibilityStatus)}
            </Box>
          </Box>

          <Divider sx={{ borderColor: COLORS.border }} />

          <Box sx={{ py: 0.75 }}>
            <MenuItem
              onClick={() => {
                onClose();
                onViewStore?.(menuRow);
              }}
              sx={{
                py: 1,
                px: 2,
                mx: 0.75,
                my: 0.25,
                borderRadius: '8px',
                '&:hover': { bgcolor: 'rgba(63, 63, 110, 0.06)' },
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <VisibilityOutlinedIcon fontSize="small" sx={{ color: COLORS.ink }} />
              </ListItemIcon>
              <ListItemText
                primary="View store"
                primaryTypographyProps={{
                  fontFamily: 'Inter Regular, sans-serif',
                  fontSize: 14,
                  color: COLORS.ink,
                }}
              />
            </MenuItem>
            <MenuItem
              onClick={onClose}
              sx={{
                py: 1,
                px: 2,
                mx: 0.75,
                my: 0.25,
                borderRadius: '8px',
                '&:hover': { bgcolor: 'rgba(63, 63, 110, 0.06)' },
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <EditOutlinedIcon fontSize="small" sx={{ color: COLORS.ink }} />
              </ListItemIcon>
              <ListItemText
                primary="Edit store"
                primaryTypographyProps={{
                  fontFamily: 'Inter Regular, sans-serif',
                  fontSize: 14,
                  color: COLORS.ink,
                }}
              />
            </MenuItem>
            <MenuItem
              onClick={() => {
                onClose();
                onUpdateStatus?.(menuRow);
              }}
              sx={{
                py: 1,
                px: 2,
                mx: 0.75,
                my: 0.25,
                borderRadius: '8px',
                '&:hover': { bgcolor: 'rgba(63, 63, 110, 0.06)' },
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <SyncAltOutlinedIcon fontSize="small" sx={{ color: COLORS.ink }} />
              </ListItemIcon>
              <ListItemText
                primary="Update status"
                primaryTypographyProps={{
                  fontFamily: 'Inter Regular, sans-serif',
                  fontSize: 14,
                  color: COLORS.ink,
                }}
              />
            </MenuItem>
          </Box>

          <Divider sx={{ borderColor: COLORS.border }} />

          <Box sx={{ py: 0.75 }}>
            <MenuItem
              onClick={onClose}
              sx={{
                py: 1,
                px: 2,
                mx: 0.75,
                my: 0.25,
                borderRadius: '8px',
                '&:hover': { bgcolor: '#fee2e2' },
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <DeleteOutlineIcon fontSize="small" sx={{ color: '#dc2626' }} />
              </ListItemIcon>
              <ListItemText
                primary="Delete store"
                primaryTypographyProps={{
                  fontFamily: 'Inter Regular, sans-serif',
                  fontSize: 14,
                  color: '#dc2626',
                }}
              />
            </MenuItem>
          </Box>
        </>
      )}
    </Menu>
  );
}
